class SpinTicker {

    private _lastDelta: number;
    private _time: number;
    private _raf: number;
    private _onLoop: (delta: number) => void;
    private _stopped: boolean;
    private _paused: boolean;
    private _hiddenName: string;
    private _visibilityChangeName: string;
    private _onVisibilityChange: () => void;

    constructor() {

        this._lastDelta = 16;
        this._time = 0;

        this._onLoop = () => {};
        this._stopped = true;
        this._paused = false;

        this._hiddenName = "hidden";
        this._visibilityChangeName = "visibilitychange";

        this._onVisibilityChange = () => {

            if(document[this._hiddenName]) {
                this._pause();
            } else {

                if(this._stopped) {
                    return;
                }

                this._play();
            }
        };

        this.init();
    }

    init () {
        this._initDocumentHidden();
        document.addEventListener(this._visibilityChangeName, this._onVisibilityChange);
    }

    setOnLoop (func) {
        this._onLoop = func;
    }

    _initDocumentHidden () {
        // @ts-ignore
        if (typeof document.msHidden !== "undefined") {
            this._hiddenName = "msHidden";
            this._visibilityChangeName = "msvisibilitychange";
        } else {

            // @ts-ignore
            if (typeof document.webkitHidden !== "undefined") {
                this._hiddenName = "webkitHidden";
                this._visibilityChangeName = "webkitvisibilitychange";
            }
        }
    }

    _play () {
        this._paused = false;
        this._stopped = true;
        this.start();
    }

    _pause () {
        this._paused = true;
        this._stopRAF();
    }

    _stopRAF () {
        window.cancelAnimationFrame(this._raf);
    }

    _loop (time) {

        if(this._stopped || this._paused) {
            return;
        }

        this._raf = window.requestAnimationFrame((time) => {
            this._loop(time);
        });

        var delta = time - this._time;
        this._time = time;

        if(delta > 40) {
            delta = 40;
        }

        this._onLoop(delta);
        this._lastDelta = delta;

    }

    start () {

        if(!this._stopped) {
            return;
        }

        this._stopped = false;
        this._paused = false;

        this._time = window.performance.now();

        this._raf = window.requestAnimationFrame(() => {
            this._loop(this._time);
        });
    };

    stop () {
        this._stopped = true;
        this._stopRAF();
    }

    isRunning () {
        return !this._stopped;
    }

    destroy () {
        this.stop();
        // @ts-ignore
        document.removeEventListener(window.visibilityChange, this._onVisibilityChange);
    }
}

export default SpinTicker;